const USER_KEY = "user";
const TOKEN_KEY = "token";

export interface AuthUser {
  id: string | number;
  account: string;
  nickname?: string;
  phone?: string;
  position?: string;
  enterprise_id?: string | number;
  department_id?: string | number;
  token?: string;
  enterprise?: {
    id?: string | number;
    title?: string;
    address?: string;
    /** 最迟退货天数（完成时间起算） */
    latest?: number | string;
    [key: string]: unknown;
  };
  department?: {
    id?: string | number;
    title?: string;
    [key: string]: unknown;
  };
  is_canedit?: boolean | number | string;
  /** 是否可跨科室查看/筛选（为 true 时显示科室下拉） */
  is_divide?: boolean | number | string;
  [key: string]: unknown;
}

export function getToken(): string | null {
  return localStorage.getItem(TOKEN_KEY);
}

export function setToken(token: string) {
  localStorage.setItem(TOKEN_KEY, token);
}

export function getUser<T = AuthUser>(): T | null {
  const raw = localStorage.getItem(USER_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as T;
  } catch {
    return null;
  }
}

export function setUser(user: AuthUser) {
  localStorage.setItem(USER_KEY, JSON.stringify(user));
  if (user.token) {
    setToken(String(user.token));
  }
}

export function isLoggedIn(): boolean {
  return !!getUser();
}

/** 是否代采账号（可跨科室 / 代购下单） */
export function isDivideAccount(user: AuthUser | null | undefined = getUser()): boolean {
  const flag = user?.is_divide;
  return flag === true || flag === 1 || flag === '1';
}

export function clearAuth() {
  localStorage.removeItem(USER_KEY);
  localStorage.removeItem(TOKEN_KEY);
}

/** 强制跳转登录页（清除登录缓存） */
export function redirectToLogin(options?: { replaceHistory?: boolean }) {
  clearAuth();
  const replaceHistory = options?.replaceHistory ?? false;

  if (replaceHistory) {
    const base = (__BASE_PATH__ || "/").replace(/\/$/, "");
    // replace 掉当前历史记录，降低回退到已退出页面的可能
    window.location.replace(`${base}/login`);
    return;
  }

  if (typeof window.REACT_APP_NAVIGATE === "function") {
    window.REACT_APP_NAVIGATE("/login", { replace: true });
    return;
  }
  const base = (__BASE_PATH__ || "/").replace(/\/$/, "");
  window.location.href = `${base}/login`;
}
